import { useNavigate } from "react-router-dom";
import { vw } from "../../../lib/utils/responsiveUtils";
import Button from "../../atoms/button";

export default function FailScreen({ message }: { message?: string }) {

  const navigate = useNavigate();
  return (
    <div className="flex flex-col justify-center items-center h-screen">
      <div className="flex flex-col justify-center items-center text-center flex-1">
        <img
          src="/icons/ic-notice.webp"
          style={{ width: vw(40), height: vw(40) }}
        />
        <p className="font-bold pt-[14px]" style={{ fontSize: vw(24) }}>
          예약 실패
        </p>
        <span
          className="text-[#888] font-[500] py-[13px]"
          style={{ fontSize: vw(14) }}
        >
          {message || "라운드 예약을 실패하였습니다."}
        </span>
      </div>
      <div className="z-50 sticky bottom-0 left-0 w-full p-[15px] bg-white flex gap-[10px]">
        <Button
          onClick={() => navigate("/")}
          className="w-full font-bold h-[50px]"
          variant="white"
          label="홈으로"
        />
      </div>
    </div>
  );
}
